import { Global, css } from '@emotion/react';
import { FC } from 'react';

import fonts from './styles/fonts';
import globals from './styles/globals';

const GlobalStyles: FC = () => (
    <Global
        styles={(theme) => css`
            ${globals(theme)}
            ${fonts(theme)}
        `}
    />
);

export default GlobalStyles;
